import { adminHttpClient } from '../commons/adminHttpClient'

export interface BenefitUsageOverviewByMonthResponse {
  monthShort: string
  reimbursed: number
}

const getBenefitUsageByMonth = (planPeriodId?: string): Promise<BenefitUsageOverviewByMonthResponse[]> => {
  return adminHttpClient.get(`/Benefit/EmployeeBenefitUsageByMonth/${planPeriodId}`)
}

export default getBenefitUsageByMonth
